
import * as XLSX from "xlsx";
import Papa from "papaparse";
import { supabase } from "@/integrations/supabase/client";
import { toast } from "@/hooks/use-toast";

interface ImportedClient {
  school_id: string;
  nama_sekolah: string;
}

export const requiredColumns = ["school_id", "nama_sekolah"];

export const validateFileData = (data: any[]) => {
  if (data.length === 0) {
    return { isValid: false, error: "The file contains no data." };
  }

  const columns = Object.keys(data[0]);
  const missingColumns = requiredColumns.filter(col => !columns.includes(col));

  if (missingColumns.length > 0) {
    return {
      isValid: false,
      error: `Missing required columns: ${missingColumns.join(", ")}`
    };
  }

  return { isValid: true, error: null };
};

export const processExcelFile = async (file: File): Promise<any[]> => {
  const buffer = await file.arrayBuffer();
  const workbook = XLSX.read(buffer);
  const sheetName = workbook.SheetNames[0];
  const worksheet = workbook.Sheets[sheetName];
  return XLSX.utils.sheet_to_json(worksheet);
};

export const processCsvFile = (file: File): Promise<any[]> => {
  return new Promise((resolve, reject) => {
    Papa.parse(file, {
      header: true,
      skipEmptyLines: true,
      complete: (results) => resolve(results.data),
      error: (error) => reject(error)
    });
  });
};

export const importClientsToSupabase = async (data: any[]): Promise<{ success: boolean; error?: string }> => {
  // Only include required fields when mapping data
  const clients: ImportedClient[] = data.map(row => ({
    school_id: String(row.school_id),
    nama_sekolah: String(row.nama_sekolah)
  }));

  const batchSize = 100;
  let hasErrors = false;
  let errorDetails = "";

  for (let i = 0; i < clients.length; i += batchSize) {
    const batch = clients.slice(i, i + batchSize);
    const { error } = await supabase.from('clients').insert(batch);
    
    if (error) {
      console.error('Error inserting clients batch:', error);
      hasErrors = true;
      errorDetails = error.message;
      break;
    }
  }

  if (hasErrors) {
    return { success: false, error: errorDetails };
  }

  return { success: true };
};
